import { defineStore } from 'pinia';

interface ThemeState {
  stationBgColor: { [key: string]: any }; // 小站背景色配置
  stationThemeConfig: any[]; // 小站主题配置
}

// 主题配置
export const useThemeStore = defineStore({
  id: 'theme',
  state: (): ThemeState => {
    return {
      stationBgColor: {}, // 小站背景色配置
      stationThemeConfig: [], // 小站主题配置
    };
  },
  getters: {},
  actions: {
    /**
     * 更新小站背景色配置
     * @param data {object} 小站背景色配置
     */
    async setStationBgColor(data = {}) {
      this.stationBgColor = data;
    },

    /**
     * 更新小站主题配置
     * @param list {array} 小站主题配置
     */
    async setStationThemeConfig(list = []) {
      this.stationThemeConfig = list;
    },
  },
});
